const $ede97c4bfefd805a$var$initColourPicker = function() {
    let colourOptionButtons = document.getElementsByClassName("colour-option");
    for(let i = 0; i < colourOptionButtons.length; i++)colourOptionButtons[i].addEventListener('click', $ede97c4bfefd805a$var$selectColourOption);
};
function $ede97c4bfefd805a$var$selectColourOption(event) {
    let optionSelected = event.srcElement.dataset.colour;
    document.body.dataset.colour = optionSelected;
    $ede97c4bfefd805a$var$updateSelectedOption(optionSelected);
}
function $ede97c4bfefd805a$var$updateSelectedOption(colour) {
    let colourOptionButtons = document.getElementsByClassName("colour-option");
    for(let i = 0; i < colourOptionButtons.length; i++)if (colourOptionButtons[i].dataset.colour == colour) colourOptionButtons[i].dataset.selected = true;
    else colourOptionButtons[i].dataset.selected = false;
}
var $ede97c4bfefd805a$export$2e2bcd8739ae039 = $ede97c4bfefd805a$var$initColourPicker;


let $24e87f2b64c7c1bd$var$navMenuOpen = false;
(0, $ede97c4bfefd805a$export$2e2bcd8739ae039)();
$24e87f2b64c7c1bd$var$initMobileNav();
$24e87f2b64c7c1bd$var$initLogoJiggles();
const $24e87f2b64c7c1bd$var$studentSwiper = new Swiper('.student-slides', {
    // Optional parameters
    direction: 'horizontal',
    loop: true,
    pagination: {
        el: '.student-pagination'
    },
    a11y: {
        prevSlideMessage: 'Previous slide',
        nextSlideMessage: 'Next slide'
    },
    autoplay: {
        delay: 2000
    }
});
const $24e87f2b64c7c1bd$var$teacherSwiper = new Swiper('.teacher-slides', {
    // Optional parameters
    direction: 'horizontal',
    loop: true,
    pagination: {
        el: '.teacher-pagination'
    },
    a11y: {
        prevSlideMessage: 'Previous slide',
        nextSlideMessage: 'Next slide'
    },
    autoplay: {
        delay: 2000
    }
});
function $24e87f2b64c7c1bd$var$initMobileNav() {
    let navElement = document.getElementById("navigation");
    let mobileMenu = document.getElementById("mobile-menu");
    navElement.addEventListener('click', ()=>{
        mobileMenu.classList.add("animate-spin");
        if ($24e87f2b64c7c1bd$var$navMenuOpen) {
            navElement.classList.remove("open");
            $24e87f2b64c7c1bd$var$navMenuOpen = false;
        } else {
            navElement.classList.add("open");
            $24e87f2b64c7c1bd$var$navMenuOpen = true;
        }
    });
    mobileMenu.addEventListener('animationend', ()=>{
        mobileMenu.classList.remove("animate-spin");
    });
}
function $24e87f2b64c7c1bd$var$initLogoJiggles() {
    let headerLogoElement = document.getElementById("logo-header");
    let footerLogoElement = document.getElementById("logo-footer");
    console.log(headerLogoElement);
    headerLogoElement.addEventListener('pointerenter', ()=>{
        headerLogoElement.classList.add("animate");
    });
    headerLogoElement.addEventListener('animationend', ()=>{
        headerLogoElement.classList.remove('animate');
    });
    footerLogoElement.addEventListener('pointerenter', ()=>{
        footerLogoElement.classList.add("animate");
    });
    footerLogoElement.addEventListener('animationend', ()=>{
        footerLogoElement.classList.remove("animate");
    });
}


//# sourceMappingURL=journeyinto-web.ac9e6d48.js.map
